exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-video[data-v-0d6dc4f6]{width:100%}", ""]);

// exports
